import { render, staticRenderFns } from "./LogDisplay.vue?vue&type=template&id=3876b8b7&"
import script from "./LogDisplay.vue?vue&type=script&lang=js&"
export * from "./LogDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LogDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports